import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.AccountPaymentExtension1,
  LocationVarKey.AccountPaymentExtension2,
  LocationVarKey.AfterNavigateAccountLoginPaymentExtension,
  LocationVarKey.AfterNavigateAccountLoginPaymentExtension1,
  LocationVarKey.AfterNavigateAccountLoginPaymentExtension2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Payment Extension
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountPaymentExtension1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountPaymentExtension2}
        enableSwitchVar={LocationVarKey.AccountPaymentExtension2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginPaymentExtension}
          label="Ask if they want to be navigated to your Account Login URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([
            IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPaymentExtension, "1"),
            IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
          ])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPaymentExtension, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPaymentExtension, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginPaymentExtension1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPaymentExtension, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginPaymentExtension2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginPaymentExtension2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
